import "@fontsource/lexend";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import cookie from 'react-cookies';
import styled from "styled-components";
import Request from "../based/Request";
import Common from "../based/Common";
import ArtworkDesktop from "./Artwork/ArtworkDesktop";
import ArtworkMobile from "./Artwork/ArtworkMobile";
import MainDesktop from "./Main/MainDesktop";
import MainMobile from "./Main/MainMobile";
import StatisticDesktop from "./Statistic/StatisticDesktop";
import StatisticMobile from "./Statistic/StatisticMobile";
import StreamDesktop from "./Stream/StreamDesktop";
import StreamMobile from "./Stream/StreamMobile";
import Logo from "./components/Image/LogoArtist.svg";
import Background from "./components/Image//BG_Artist.png";
import ModalUpdateInfo from "./components/ModalUpdateInfo";

export const SCREEN = {
    MAIN: "main",
    STREAM: "stream",
    ARTWORK: "artwork",
    STATISTIC: "statistic",
};
const MENU = [
    { id: 0, name: "Trang chủ", screen: "main" },
    { id: 1, name: "Livestream", screen: "stream" },
    { id: 2, name: "Artwork", screen: "artwork" },
    // { id: 3, name: "Thống kê", screen: "statistic" },
];
function Artist(props) {
    const [tabActive, setTabActive] = useState(SCREEN.MAIN);
    const location = useLocation();
    const history = useHistory();
    const isDesktop = window.innerWidth > 768;
    const [user, setUser] = useState({});
    const [isModal, setIsModal] = useState(false)

    useEffect(() => {
        getPersonalInfo();
    }, []);

    function getPersonalInfo() {
        Request.Get("/api/Artist/get-artist-info")
            .then((res) => {
                let data = res.data;
                setUser(data);
                if(!data.isActive){
                    history.push("/verify")
                }
            })
            .catch((err) => {});
    }



    useEffect(() => {
        let check = false;
        if (props.match.params.tab) {
            Object.keys(SCREEN).forEach((value, idx, arr) => {
                if (SCREEN[value] == props.match.params.tab) {
                    setTabActive(props.match.params.tab);
                    check = true;
                }
            });
            if (!check) {
                setTabActive(SCREEN.MAIN);
            }
        }
    }, [props.match.params.tab]);

    useEffect(() => {
        const pathname = location.pathname;
        if (pathname == "/" || pathname == "/artist") {
            setTabActive(SCREEN.MAIN);
        }
    }, [location]);

    const renderMenu = () => {
        return MENU.map((item, idx) => {
            return (
                <li
                    className={`${tabActive == item.screen ? "active" : ""}`}
                    onClick={() => {
                        history.push(`/artist/${item.screen}`);
                        setTabActive(item.screen);
                    }}
                    key={idx}
                >
                    {item.name}
                </li>
            );
        });
    };

    const handleUpdateInfo = () =>{
        setIsModal(true)
    }


    const handleLogout = () =>{
        Common.RemoveToken();
        cookie.remove('token');
        window.location.href = '/login';
          
    }

    return (
        <React.Fragment>
            {isDesktop ? (
                <ArtistStyle>
                    <div className="artist">
                        <nav>
                            <div className="logo">
                                <img src={Logo} alt="logo" />
                            </div>
                            <ul>{renderMenu()}</ul>
                        </nav>
                        <div className="body-artist">
                            <header>
                                <div className="user-info">
                                    <div onClick={()=>{
                                        handleUpdateInfo()
                                    }} className="avatar-user">
                                        {user.avatar ? <img src={user.avatar} alt="avatar" /> : <img src={Logo} alt="avatar mặc định" />}
                                    </div>
                                    <div className="name-user">
                                        <span>Xin chào,</span>
                                        <span className="name">
                                        {user.nickName ? user.nickName : user.firstName && user.lastName && user.firstName + " " + user.lastName}
                                        </span>
                                    </div>
                                </div>
                                {/* <div className="right-info">
                                    <span >Chỉnh sửa thông tin</span>
                                    <span onClick={()=>{
                                        handleLogout()
                                    }}>Đăng xuất</span>
                                </div> */}
                            </header>
                            <main>
                                {tabActive == SCREEN.MAIN && <MainDesktop />}
                                {tabActive == SCREEN.STREAM && <StreamDesktop />}
                                {tabActive == SCREEN.ARTWORK && <ArtworkDesktop />}
                                {tabActive == SCREEN.STATISTIC && <StatisticDesktop />}                                
                            </main>
                        </div>
                    </div>
                    {isModal && <ModalUpdateInfo setIsModal={setIsModal} user={user} getPersonalInfo={getPersonalInfo} />}
                </ArtistStyle>
            ) : (
                <ArtistMobileStyle>
                    <div className="artist-mobile">
                        {tabActive == SCREEN.MAIN && <MainMobile />}
                        {tabActive == SCREEN.STREAM && <StreamMobile />}
                        {tabActive == SCREEN.ARTWORK && <ArtworkMobile />}
                        {tabActive == SCREEN.STATISTIC && <StatisticMobile />}
                    </div>
                </ArtistMobileStyle>
            )}
        </React.Fragment>
    );
}
const ArtistMobileStyle = styled.div`
    font-family: "Lexend";
    font-style: normal;
`;
const ArtistStyle = styled.div`
    font-family: "Lexend";
    font-style: normal;

    .artist {
        width: 100%;
        margin: 0 auto;
        position: relative;

        .body-artist {
            margin-left: ${window.innerWidth > 1024 ? "calc(1024px / 5)" : "20%"};
            width: ${window.innerWidth > 1024 ? "calc(100% - 1024px / 5)" : "80%"};
            min-height: 100vh;
            background-color: #313131;

            header {
                height: 190px;
                width: 100%;
                background-color: #313131;
                padding:0 24px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                background-image:linear-gradient(to bottom, rgba(49,49, 49, 0), rgba(49,49, 49, 1)), url(${Background});
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;

                .right-info{
                    display: flex;
                    align-items: center;

                    span{
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 18px;
                        letter-spacing: -0.3px;
                        color: #06F1B9;
                        margin-left: 25px;
                        cursor: pointer;
                    }
                }

                .user-info {
                    display: flex;
                    align-items: center;
                    transform: translateY(-30px);

                    .avatar-user {
                        width: 42px;
                        height: 42px;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            border-radius: 50%;
                            border: 2px solid #06F1B9;
                        }
                    }
                    .name-user {
                        margin-left: 21px;

                        span {
                            font-weight: 600;
                            font-size: 20px;
                            line-height: 25px;
                            letter-spacing: -0.3px;
                            color: #ffffff;

                            &.name {
                                color: #06f1b9;
                                margin-left: 7px;
                            }
                        }
                    }
                }
            }

            main {
                width: 100%;
                margin-top: -48px;
            }
        }

        nav {
            position: fixed;
            top: 0;
            bottom: 0;
            width: 20%;
            max-width: calc(1024px / 5);
            background-color: #3a3a3a;

            .logo {
                height: 142px;
                width: 100%;
                display: grid;
                place-items: center;

                img {
                    width: 116px;
                    height: 43px;
                    object-fit: contain;
                }
            }

            ul {
                padding: 0;
                list-style: none;

                li {
                    height: 46px;
                    width: 100%;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 20px;
                    letter-spacing: -0.3px;
                    color: #ffffff;
                    display: flex;
                    align-items: center;
                    padding-left: 21px;
                    cursor: pointer;

                    &.active {
                        color: #06f1b9;
                        border-left: 5px solid #06f1b9;
                        cursor: default;
                        background-color: #464646;
                        padding-left: 16px;
                    }
                }
            }
        }
    }
`;
export default Artist;



// WEBPACK FOOTER //
// ./src/artist-ui/Artist.js